import { Heading } from '@postscript/components';
import styled from 'styled-components';

export const StyledDivider = styled.div`
  border-top: 2px solid var(--border-color-dim);
  margin-top: var(--spacing-4);
`;

export const StyledCurrentAddOnsHeading = styled(Heading).attrs({
  size: 'x-small',
})`
  margin-top: var(--spacing-4);
  margin-bottom: var(--spacing-4);
`;
